import React from 'react';
import { isEmpty } from 'check-tool';

import { deleteNotificationItem, sendPushNotification } from 'backend/MagicBall/Notification';
import { deleteUserItem, getUsersListByCntPushNotification, getUsersList } from 'backend/MagicBall/User';


const NotificationListMagicBall = ({ list, callSuccess }) => {

  const clickOnEditNotification = () => {
    
  };

  const handleDelete = (id) => {
    if (window.confirm("Вы хотите удадить PUSH-нотификацию?")) {
      deleteNotificationItem(id)
        .then(() => callSuccess());
    }
  };

  const handlePush = (lang, notification) => {
    if (notification.number < 99999) {
      getUsersListByCntPushNotification(notification.number - 1)
        .then((result) => {
          console.log('result 1', result);
          const resultCut = result.slice(1, 1000);
          sendPushNotification(lang, resultCut, notification)
            .then(() => {
              alert('Success send to all');
            });
          let cntDelete = 0;
          resultCut.map((value) => {
            if (isEmpty(value.language)) {
              deleteUserItem(value.uid);
              cntDelete++;
            }
          });
          console.log('cntDelete 1: ', cntDelete);
        })
        .catch((error) => {
          console.log('Error getUsersListByCntPushNotification', error);
        });
    } else {
      getUsersList()
        .then((result) => {
          console.log('result 2', result);
          const resultCut = result.slice(1, 1000);
          console.log('resultCut', resultCut);
          sendPushNotification(lang, resultCut, notification)
            .then(() => {
              alert('Success send to all');
            });
          let cntDelete = 0;
          resultCut.map((value) => {
            if (isEmpty(value.language)) {
              deleteUserItem(value.uid);
              cntDelete++;
            }
          });
          console.log('cntDelete 2: ', cntDelete);
        })
        .catch((error) => {
          console.log('Error getUsersList', error);
        });
    }
  };

  return (
    <div className="row">
      <div className="col-md-12">
        <br /><br />
        <table id="simple-table" className="table table-bordered table-hover">
					<thead>
						<tr>
							<th>Название</th>
							<th>Push-текст</th>
							<th className="hidden-480">Дата редактирования</th>
							<th></th>
						</tr>
				  </thead>

					<tbody>
            {list.map((value) => {
              const dateUpdated = new Date(value.dateUpdated).toLocaleDateString();
              return (
                <tr key={value.id}>
                  <td>
                    EN: {value.title.en} <hr/>
                    RU: {value.title.ru} <hr/>
                    UK: {value.title.uk} <hr/>
                    ES: {value.title.es} <hr/>
                    PT: {value.title.pt} <hr/>
                    IT: {value.title.it} <hr/>
                    CS: {value.title.cs} <hr/>
                    DE: {value.title.de} <hr/>
                    FR: {value.title.fr} <hr/>
                    NL: {value.title.nl} <hr/>
                    PL: {value.title.pl} <hr/>
                    TK: {value.title.tk} <hr/>
                    SL: {value.title.sl} <hr/>
                    TH: {value.title.th} <hr/>
                    HI: {value.title.hi} <hr/>
                    ZH: {value.title.zh} <hr/>
                    ZH-CN: {value.title.zhCn} <hr/>
                    Ja: {value.title.ja} <hr/>
                    EL: {value.title.el} <hr/>
                    SV: {value.title.sv} <hr/>
                    NO: {value.title.no} <hr/>
                  </td>
                  <td>
                    EN: {value.content.en} <hr/>
                    RU: {value.content.ru} <hr/>
                    UK: {value.content.uk} <hr/>
                    ES: {value.content.es} <hr/>
                    PT: {value.content.pt} <hr/>
                    IT: {value.content.it} <hr/>
                    CS: {value.content.cs} <hr/>
                    DE: {value.content.de} <hr/>
                    FR: {value.content.fr} <hr/>
                    NL: {value.content.nl} <hr/>
                    PL: {value.content.pl} <hr/>
                    TK: {value.content.tk} <hr/>
                    SL: {value.content.sl} <hr/>
                    TH: {value.content.th} <hr/>
                    HI: {value.content.hi} <hr/>
                    ZH: {value.content.zh} <hr/>
                    ZH-CN: {value.content.zhCn} <hr/>
                    JA: {value.content.ja} <hr/>
                    EL: {value.content.el} <hr/>
                    SV: {value.content.sv} <hr/>
                    NO: {value.content.no} <hr/>
                  </td>
                  <td>{dateUpdated}<br />Number: {value.number}</td>
                  <td>
                    <div className="btn-group">
											<button
                        className="btn btn-xs btn-success"
                        title="Отправить всем пользователям"
                        onClick={() => handlePush('all', value)}
                      >
												<i className="ace-icon fa fa-check bigger-120"></i>
											</button>
                      <br/><br/>
                      <button
                        className="btn btn-xs btn-info"
                        title="Отправить всем пользователям"
                        onClick={() => handlePush('en', value)}
                      >
												<i className="ace-icon fa fa-check bigger-120"></i> EN
											</button>
                      <br/><br/>
                      <button
                        className="btn btn-xs btn-info"
                        title="Отправить всем пользователям"
                        onClick={() => handlePush('ru', value)}
                      >
												<i className="ace-icon fa fa-check bigger-120"></i> RU
											</button>
                      <br/><br/>
                      <button
                        className="btn btn-xs btn-info"
                        title="Отправить всем пользователям"
                        onClick={() => handlePush('uk', value)}
                      >
												<i className="ace-icon fa fa-check bigger-120"></i> UK
											</button>
                      <br/><br/>
                      <button
                        className="btn btn-xs btn-info"
                        title="Отправить всем пользователям"
                        onClick={() => handlePush('es', value)}
                      >
												<i className="ace-icon fa fa-check bigger-120"></i> ES
											</button>
                      <br/><br/>
                      <button
                        className="btn btn-xs btn-info"
                        title="Отправить всем пользователям"
                        onClick={() => handlePush('pt', value)}
                      >
												<i className="ace-icon fa fa-check bigger-120"></i> PT
											</button>
                      <br/><br/>
                      <button
                        className="btn btn-xs btn-info"
                        title="Отправить всем пользователям"
                        onClick={() => handlePush('it', value)}
                      >
												<i className="ace-icon fa fa-check bigger-120"></i> IT
											</button>

                      <br/><br/>
                      <button
                        className="btn btn-xs btn-info"
                        title="Отправить всем пользователям"
                        onClick={() => handlePush('cs', value)}
                      >
												<i className="ace-icon fa fa-check bigger-120"></i> CS
											</button>
                      <br/><br/>
                      <button
                        className="btn btn-xs btn-info"
                        title="Отправить всем пользователям"
                        onClick={() => handlePush('de', value)}
                      >
												<i className="ace-icon fa fa-check bigger-120"></i> DE
											</button>
                      <br/><br/>
                      <button
                        className="btn btn-xs btn-info"
                        title="Отправить всем пользователям"
                        onClick={() => handlePush('fr', value)}
                      >
												<i className="ace-icon fa fa-check bigger-120"></i> FR
											</button>

                      <br/><br/>
                      <button
                        className="btn btn-xs btn-info"
                        title="Отправить всем пользователям"
                        onClick={() => handlePush('el', value)}
                      >
												<i className="ace-icon fa fa-check bigger-120"></i> EL
											</button>
                      <br/><br/>
                      <button
                        className="btn btn-xs btn-info"
                        title="Отправить всем пользователям"
                        onClick={() => handlePush('sv', value)}
                      >
												<i className="ace-icon fa fa-check bigger-120"></i> SV
											</button>
                      <br/><br/>
                      <button
                        className="btn btn-xs btn-info"
                        title="Отправить всем пользователям"
                        onClick={() => handlePush('no', value)}
                      >
												<i className="ace-icon fa fa-check bigger-120"></i> NO
											</button>

                      <hr/>
                      <br/><br/>
											<button className="btn btn-xs btn-info">
												<i className="ace-icon fa fa-pencil bigger-120"></i>
											</button>

											<button className="btn btn-xs btn-danger" onClick={() => handleDelete(value.id)}>
												<i className="ace-icon fa fa-trash-o bigger-120"></i>
											</button>
										</div>
                  </td>
                </tr>
              );
            })}
					</tbody>
				</table>
      </div>
    </div>
  );
};

export default NotificationListMagicBall;
